import { useState } from 'react';
import UploadPage from './pages/UploadPage';
import ReaderPage from './pages/ReaderPage';
import { loadLibrary, addBook, loadBookContent, deleteBook, renameBook } from './utils/library';

export default function App() {
  const [library, setLibrary] = useState(() => loadLibrary());
  const [openBook, setOpenBook] = useState(null);

  function handleLoad({ title, text }) {
    const { id, library: updated } = addBook(library, title, text);
    setLibrary(updated);
    setOpenBook({ id, title, text });
  }

  function handleOpen(id) {
    const content = loadBookContent(id);
    if (content) setOpenBook({ id, ...content });
  }

  function handleClose() {
    setOpenBook(null);
  }

  function handleDelete(id) {
    setLibrary(prev => deleteBook(id, prev));
    if (openBook?.id === id) setOpenBook(null);
  }

  function handleRename(id, newTitle) {
    setLibrary(prev => renameBook(id, newTitle, prev));
  }

  return openBook
    ? <ReaderPage book={openBook} onClose={handleClose} />
    : <UploadPage library={library} onLoad={handleLoad} onOpen={handleOpen} onDelete={handleDelete} onRename={handleRename} />;
}
